
var Object = require('./object');

/**
 * The equivalent of a SQL expression.
 */
module.exports = new Class({
	Extends: Object
	,Tag: 'sql-expr'
});

